import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  Bell,
  Plus,
  UserCircle,
  Compass,
  CalendarBlank,
  Users,
  ArrowUpRight,
  Translate,
} from "@phosphor-icons/react";
import { useEffect } from "react";
import { useApp } from "../context";
import { BrandLogo } from "./BrandLogo";
import { platformBrand } from "../../shared/platform-brand";
export default function Layout() {
  const { user, demo, language, setLanguage, logout, t } = useApp(),
    location = useLocation(),
    navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
      <header className="site-header">
        <Link
          to="/"
          className="wordmark"
          aria-label={t("聚一次 ホーム", "聚一次首页")}
        >
          <BrandLogo />
        </Link>
        <nav className="desktop-nav" aria-label={t("メインメニュー", "主导航")}>
          <NavLink to="/" end>
            {t("イベント", "活动")}
          </NavLink>
          <NavLink to="/brands">{t("ブランド", "活动品牌")}</NavLink>
          <NavLink to="/venue">{t("会場", "活动场地")}</NavLink>
        </nav>
        <div className="header-actions">
          <button
            className="language-button"
            onClick={() => setLanguage(language === "ja" ? "zh" : "ja")}
            aria-label={t("切换为中文", "切换为日语")}
          >
            <Translate size={18} />
            {language === "ja" ? "中文" : "日本語"}
          </button>
          <Link to="/host" className="button brand host-cta">
            <Plus size={18} />
            {t("開催する", "发起活动")}
          </Link>
          {user ? (
            <>
              <Link
                to="/notifications"
                className="icon-button"
                aria-label={t("お知らせ", "通知")}
              >
                <Bell size={22} />
              </Link>
              <details className="account-menu">
                <summary aria-label={t("アカウントメニュー", "账号菜单")}>
                  <UserCircle size={30} />
                </summary>
                <div>
                  <span className="menu-email">{user.email}</span>
                  <Link to="/me" aria-label={t("マイイベント", "我的活动")}>
                    {t("マイイベント", "我的活动")}
                  </Link>
                  <Link
                    to="/profile"
                    aria-label={t("プロフィール", "个人资料")}
                  >
                    {t("プロフィール", "个人资料")}
                  </Link>
                  <Link
                    to="/host"
                    aria-label={t("主催者ダッシュボード", "主办方工作台")}
                  >
                    {t("主催者ダッシュボード", "主办方工作台")}
                  </Link>
                  {user.role === "admin" && (
                    <Link to="/admin" aria-label={t("運営管理", "平台管理")}>
                      {t("運営管理", "平台管理")}
                    </Link>
                  )}
                  <button
                    aria-label={t("ログアウト", "退出登录")}
                    onClick={async () => {
                      await logout();
                      navigate("/");
                    }}
                  >
                    {t("ログアウト", "退出登录")}
                  </button>
                </div>
              </details>
            </>
          ) : (
            <Link
              to={"/login?return=" + encodeURIComponent(location.pathname)}
              className="login-link"
            >
              {t("ログイン", "登录")}
            </Link>
          )}
        </div>
      </header>
      {demo && (
        <div className="demo-strip">
          {t(
            "デモ環境 · イベント・写真・会場情報はサンプルです。メールはローカル受信箱に保管します。",
            "演示环境 · 活动、图片及场地信息均为样例，邮件保存到本地收件箱。",
          )}
          <Link to="/dev/mail">
            {t("受信箱", "收件箱")}
            <ArrowUpRight size={13} />
          </Link>
        </div>
      )}
      <main className="main-container">
        <Outlet />
      </main>
      <footer className="site-footer">
        <Link
          to="/"
          className="wordmark"
          aria-label={t("聚一次 ホーム", "聚一次首页")}
        >
          <BrandLogo />
        </Link>
        <p>{t("新しいまちで、出会いの一歩を。", platformBrand.tagline)}</p>
        <div>
          <Link to="/venue">{t("会場について", "关于场地")}</Link>
          <Link to="/guide">
            {t("ご利用ガイド・個人情報", "使用指南与隐私")}
          </Link>
          <span>
            © {new Date().getFullYear()} {platformBrand.name}
          </span>
        </div>
      </footer>
      <nav
        className="mobile-nav"
        aria-label={t("モバイルメニュー", "手机导航")}
      >
        <NavLink to="/" end>
          <Compass size={23} />
          {t("見つける", "发现")}
        </NavLink>
        <NavLink to="/brands">
          <Users size={23} />
          {t("ブランド", "品牌")}
        </NavLink>
        <NavLink to="/me">
          <CalendarBlank size={23} />
          {t("参加予定", "我的活动")}
        </NavLink>
        <NavLink to="/host">
          <Plus size={23} />
          {t("開催する", "主办")}
        </NavLink>
      </nav>
    </>
  );
}
